type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const VendorStatus = Object.freeze({
  USABLE: 1 as const, // ใช้งาน
  DELETE: 2 as const, // ลบ
});

export type VendorStatus = EnumLiteralsOf<typeof VendorStatus>;
